import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loader } from '../../UI';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import axios from '../../../axios';

export function BookServiceModal({serviceData, isExpired}) {
    const authToken = localStorage.getItem('access_token');
    const [isLoading, setIsLoading] = useState(true);
    const [bookingData, setBookingData] = useState({
        childId: '',
        dates: [],
        notes: '',
    });
    const [currentStep, setCurrentStep] = useState(0);
    const [show, setShow] = useState(false);
    const [childrenOpts, setChildrenOpts] = useState([]);

    const user = JSON.parse(localStorage.getItem('user'));
    const [childName, setChildName] = useState('');
    const datedOn = new Date();
    const [bookedDates, setBookedDates] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const goToNextStep = (stepData)=>{
        let newData = {...bookingData, ...stepData};
        setBookingData(newData);
        if(currentStep >= 1){
            setIsLoading(true);
            addNewBooking(newData);
        }
        else {
            setBookedDates(newData.dates);
            setCurrentStep(currentStep+1);
        }
    }

    const steps = [
        <StepOne handlers={{
            handleClose: handleClose,
            goToNextStep: goToNextStep,
            setChildName: setChildName
        }} data={{
            bookingData: bookingData,
            serviceData: serviceData,
            options: childrenOpts,
            authToken: authToken
        }}/>,
        <StepTwo
            data={{bookedDates, bookingData, serviceData, childName}}
            handlers={{handleClose, goToNextStep}}
        />
    ];

    const addNewBooking = (values) => {
        values.serviceId = serviceData.serviceId;
        values.userId = user[0].userId;
        values.total = serviceData.sessionPrice * values.dates.length;
        values.status = 'unpaid';
        values.datedOn = datedOn.getFullYear()+'-'+(datedOn.getMonth()+1)+'-'+ datedOn.getDate();
        values.dates = values.dates.toString();
        values.notes = values.notes === '' ? null : values.notes;

        axios.post('/bookings', values, {
        headers: {
            'Authorization': `Bearer ${authToken}`
        }
        })
        .then((response) => {
            if(response.data){
                if (response.status === 200) {
                    toast.success(response.data.message);
                } else {
                    toast.warn('No response from server');
                }
            }
            setIsLoading(false);
            handleClose();
        })
        .catch((error) => {
            toast.error('Something went wrong');
            console.log(error);
            setIsLoading(false);
            handleClose();
        })
    };

    const fetchChildren = () => {
        axios.get('/user-children', {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        })
        .then((response) => {
          if (response.data) {
            let opts = [...childrenOpts];
            response.data.forEach(item => {
                if (item.status === 'registered') {
                    opts.push({
                        value: item.childId,
                        label: item.firstName+' '+item.lastName
                    });
                }
            });
            setChildrenOpts(opts);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          toast.error('Couldn\'t load children');
          setIsLoading(false);
        })
    };

    useEffect(() => {
        fetchChildren();
    }, []);
    
    return (
        <>
            <Button variant='primary' className='py-2 px-3' onClick={handleShow} disabled={isExpired()}>Book Now</Button>

            <Modal show={show} size="lg" onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Book Activity</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        !isLoading ? (
                            steps[currentStep]
                        ) : (
                            <Loader />
                        )
                    }
                </Modal.Body>
            </Modal>
        </>
    );
}
